// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
/**
 * Direction indicates if the call or message was sent from Weave to a person
 * phone number (outbound) or received from a person phone number (inbound).
 */
export var Direction;
(function (Direction) {
    Direction["DIRECTION_UNSPECIFIED"] = "DIRECTION_UNSPECIFIED";
    Direction["DIRECTION_OUTBOUND"] = "DIRECTION_OUTBOUND";
    Direction["DIRECTION_INBOUND"] = "DIRECTION_INBOUND";
})(Direction || (Direction = {}));
export var Direction_index;
(function (Direction_index) {
    Direction_index[Direction_index["DIRECTION_UNSPECIFIED"] = 0] = "DIRECTION_UNSPECIFIED";
    Direction_index[Direction_index["DIRECTION_OUTBOUND"] = 1] = "DIRECTION_OUTBOUND";
    Direction_index[Direction_index["DIRECTION_INBOUND"] = 2] = "DIRECTION_INBOUND";
})(Direction_index || (Direction_index = {}));
